export class ResourceNotFound extends Error {
  constructor(message = 'resource not found') {
    super(message)

    this.name = 'ResourceNotFound'
  }
}
